import { z } from 'zod'

export const S3BucketRegion = z.enum(['eu-central-1', 'eu-central-2', 'eu-north-1'])
export type S3BucketRegion = z.infer<typeof S3BucketRegion>

export const S3BucketStatus = z.enum(['active', 'suspended', 'deleted'])
export type S3BucketStatus = z.infer<typeof S3BucketStatus>

export const S3Bucket = z.object({
  id: z.number(),
  name: z.string(),
  region: S3BucketRegion,
  status: S3BucketStatus,
  public: z.boolean(),
  storage_bytes: z.number(),
  object_count: z.number(),
  created: z.string()
})
export type S3Bucket = z.infer<typeof S3Bucket>

export const S3BucketCreateRequest = z.object({
  name: z.string().min(3).max(63),
  region: S3BucketRegion,
  public: z.boolean()
})
export type S3BucketCreateRequest = z.infer<typeof S3BucketCreateRequest>

export const S3BucketUpdateRequest = z.object({
  public: z.boolean()
})
export type S3BucketUpdateRequest = z.infer<typeof S3BucketUpdateRequest>

// Bucket names are unique across every customer, so the create form checks
// availability before submitting. The response says only whether the name
// exists, never who holds it.
export const S3BucketAvailability = z.object({
  name: z.string(),
  available: z.boolean(),
  reason: z.enum(['invalid', 'taken']).nullable()
})
export type S3BucketAvailability = z.infer<typeof S3BucketAvailability>

// Deleting a bucket switches off any credential that was scoped only to it,
// because an empty scope would otherwise mean full account access.
export const S3DeactivatedCredential = z.object({
  name: z.string(),
  access_key_id: z.string()
})
export type S3DeactivatedCredential = z.infer<typeof S3DeactivatedCredential>

export const S3BucketDeleteResponse = z.object({
  deactivated_credentials: z.array(S3DeactivatedCredential)
})
export type S3BucketDeleteResponse = z.infer<typeof S3BucketDeleteResponse>
